import { cn } from '@/lib/utils'
import {
  AlertTriangle,
  BarChart3,
  BookOpen,
  Building2,
  Headphones,
  Home,
  Library,
  ShieldAlert,
  Upload,
  Users,
} from 'lucide-react'
import { Link, Outlet, useLocation } from 'react-router-dom'

const adminNavItems = [
  {
    name: 'Dashboard',
    href: '/dashboard',
    icon: Home,
  },
  {
    name: 'Users',
    href: '/users',
    icon: Users,
  },
  {
    name: 'Crisis Alerts',
    href: '/crisis-alerts',
    icon: ShieldAlert,
  },
  {
    name: 'Organizations',
    href: '/organizations',
    icon: Building2,
  },
  {
    name: 'Import',
    href: '/import',
    icon: Upload,
  },
  {
    name: 'Analytics',
    href: '/analytics',
    icon: BarChart3,
  },
  {
    name: 'Podcasts',
    href: '/podcasts',
    icon: Headphones,
  },
  {
    name: 'Books',
    href: '/books',
    icon: BookOpen,
  },
  {
    name: 'Resources',
    href: '/resources',
    icon: Library,
  },
  {
    name: 'Dead Letter Queues',
    href: '/dlq',
    icon: AlertTriangle,
  },
]

export function AdminLayout() {
  const location = useLocation()

  return (
    <div className="flex h-[calc(100vh-4rem)]">
      {/* Sidebar */}
      <aside className="w-64 border-r bg-muted/10 flex flex-col">
        <div className="p-4 border-b">
          <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            Admin Console
          </span>
        </div>
        <nav className="flex flex-col gap-1 p-4 flex-1">
          {adminNavItems.map((item) => {
            const Icon = item.icon
            const isActive =
              location.pathname === item.href ||
              (item.href === '/users' && location.pathname.startsWith('/users'))

            return (
              <Link
                key={item.href}
                to={item.href}
                className={cn(
                  'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-gradient-to-r from-blue-600 to-blue-600 text-white shadow-md'
                    : 'text-muted-foreground hover:bg-muted hover:text-foreground',
                )}
              >
                <Icon className="h-5 w-5" />
                {item.name}
              </Link>
            )
          })}
        </nav>
        {/* Footer links */}
        <div className="border-t p-4">
          <div className="flex flex-col gap-2 text-xs text-muted-foreground">
            <div className="flex gap-4">
              <Link to="/terms-of-service" className="hover:text-foreground transition-colors">
                Terms
              </Link>
              <Link to="/privacy" className="hover:text-foreground transition-colors">
                Privacy
              </Link>
            </div>
            <p>&copy; {new Date().getFullYear()} Pelgo</p>
          </div>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto bg-gray-50/50">
        <Outlet />
      </main>
    </div>
  )
}
